import { useQuery } from '@tanstack/react-query';

import API from '@/config/api';

import { groundingQualityResponse, type UseGroundingQuality } from './Quality.schema';

export const qualityKeys = {
	all: ['quality'] as const,
	grounding: (days: number) => ['quality', 'grounding', days] as const,
};

export const useGroundingQuality = (days = 7, opts: UseGroundingQuality['opts'] = {}) =>
	useQuery<UseGroundingQuality['response']>({
		...opts,
		queryKey: qualityKeys.grounding(days),
		queryFn: () =>
			API.get('/quality/grounding', { params: { days } }).then((res) => groundingQualityResponse.parse(res.data)),
	});
